






























































import Modal from "../core/Modals/Modal.vue";
import PhotosViewer from "../core/Files/PhotosViewer.vue";
import MailEditor from "../core/Forms/MailEditor.vue";
import moment from "moment";
import "moment/locale/fr";
import StringUtils from "../utils/StringUtils";
import { EmailApi } from "../api/EmailApi";
import { Email } from "../models/Email";
import { FileApi } from "../api/FileApi";
import { SettingApi } from "../api/SettingApi";
import { Setting } from "../models/Setting";
import { Audit } from "../models/Audit";
import Evenement = Audit.Evenement;
import { JournalEntry } from "../models/JournalEntry";
import { JournalApi } from "../api/JournalApi";
import FileUploader from "../core/Forms/FileUploader.vue";
import { Contact } from "../models/Contact";

moment.locale("fr");

export default {
    name: "SignalementMailModal",
    components: { FileUploader, PhotosViewer, Modal, MailEditor },
    props: {
        showModal: Boolean,
        evenement: Evenement,
        journalFolder: JournalEntry,
    },
    data() {
        return {
            step: 0,
            saving: false,
            photos: [],
            emailData: {
                to: "",
                subject: "",
                body: "",
                bodies: [
                    {
                        text: "",
                        editable: true,
                    },
                    {
                        text: "",
                        editable: false,
                    },
                    {
                        text: "",
                        editable: true,
                    },
                ],
                attachments: [],
                photos: [],
                reference: null,
                type_notification: Email.ETypeNotification.Email,
                save_type_notification: Email.ESaveTypeNotification.Audit,
            },
            defaultContact: null,
            defaultContactRole: Contact.ERole.signalement,
            EmailApi: new EmailApi(),
            FileApi: new FileApi(),
            SettingApi: new SettingApi(),
            JournalApi: new JournalApi(),
        };
    },
    methods: {
        nextStep(): void {
            let self = this;

            self.step++;
            if (this.step === 1) {
                _.each(self.photos, function (photo) {
                    photo.shared = !!photo.selected;
                    self.FileApi.updatePhoto(photo);
                });

                let client = self.evenement.client;

                if (client) {
                    self.defaultContact = client;
                } else {
                    self.defaultContact = null;
                }

                self.emailData.subject = client ? client.nom : "";

                if (this.journalFolder && this.journalFolder.reference_id) {
                    this.emailData.subject +=
                        " - ref:" + this.journalFolder.reference_id;
                }

                self.SettingApi.get(
                    Setting.settingsKeys.mail_signalement_template
                ).then(function (setting) {
                    let body = StringUtils.replaceMailParams(setting.value);
                    let bodies = _.split(body, "{signalement}");
                    self.emailData.bodies[0].text = bodies[0];

                    self.emailData.bodies[1].text = self.evenement.statusHtml;

                    if (bodies.length > 1) {
                        self.emailData.bodies[2].text = bodies[1];
                    } else {
                        self.emailData.bodies[2].text = "";
                    }
                });
            }
        },
        // Events
        closeModal(): void {
            this.saving = false;
            this.step = 0;
            this.$emit("close-modal");
        },
        updateMailData: function (emailData) {
            this.emailData.to = emailData.to;
            this.emailData.subject = emailData.subject;
            this.emailData.body = emailData.body;
            this.emailData.recipient = emailData.recipient;
        },
        updateFilesList: function (filesIds: Array<Number>): void {
            this.emailData.attachments = filesIds;
        },
        updatePhotosList: function (photoIds: Array<Number>): void {
            this.emailData.photos = photoIds;
        },
        onUploadStart: function () {
            this.saving = true;
        },
        onUploadEnd: function () {
            this.saving = false;
        },
        sendMail() {
            let self = this;

            if (
                !self.emailData.to ||
                !StringUtils.isValidEmailList(self.emailData.to) ||
                self.saving
            )
                return;

            self.saving = true;

            self.EmailApi.create(self.emailData).then(function (res) {
                if (self.journalFolder) {
                    let newNotification = JournalEntry.createFromEmailData(
                        self.emailData,
                        self.journalFolder.id
                    );
                    self.JournalApi.save(newNotification).then(function () {
                        self.closeModal();
                    });
                } else {
                    self.closeModal();
                }
            });
        },
    },
    watch: {
        showModal: function (val: boolean) {
            if (val && this.evenement) {
                //this.emailData.reference = this.evenement.audit_id;

                this.photos = this.evenement.photos;

                if (this.photos.length < 1) {
                    this.nextStep();
                } else {
                    this.step = 0;
                }
            }
        },
    },
};
